var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 297,
    viewBox: "0 0 297 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.195 146.055L148.41 148.409L150.764 147.624L149.195 146.055Z",
    fill: "url(#paint0_radial_2836_2053)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.476 146.054L153.12 146.839L149.98 143.699L150.765 141.343L155.476 146.054Z",
    fill: "url(#paint1_radial_2836_2053)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.187 144.483L157.831 145.268L151.55 138.987L152.336 136.632L160.187 144.483Z",
    fill: "url(#paint2_radial_2836_2053)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.899 142.913L162.543 143.698L153.121 134.276L153.906 131.92L164.899 142.913Z",
    fill: "url(#paint3_radial_2836_2053)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.61 141.342L167.254 142.127L154.691 129.564L155.477 127.209L169.61 141.342Z",
    fill: "url(#paint4_radial_2836_2053)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.322 139.772L171.966 140.557L156.262 124.853L157.047 122.497L174.322 139.772Z",
    fill: "url(#paint5_radial_2836_2053)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.033 138.201L176.677 138.986L157.832 120.141L158.618 117.786L179.033 138.201Z",
    fill: "url(#paint6_radial_2836_2053)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.745 136.631L181.389 137.416L159.403 115.43L160.188 113.074L183.745 136.631Z",
    fill: "url(#paint7_radial_2836_2053)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.456 135.06L186.1 135.846L160.973 110.718L161.758 108.363L188.456 135.06Z",
    fill: "url(#paint8_radial_2836_2053)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.167 133.49L190.811 134.275L162.544 106.007L163.329 103.652L193.167 133.49Z",
    fill: "url(#paint9_radial_2836_2053)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.878 131.92L195.522 132.705L164.114 101.297L164.899 98.9408L197.878 131.92Z",
    fill: "url(#paint10_radial_2836_2053)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.589 130.349L200.234 131.134L165.684 96.5851L166.47 94.2294L202.589 130.349Z",
    fill: "url(#paint11_radial_2836_2053)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M207.302 128.778L204.946 129.564L167.255 91.8728L168.04 89.5171L207.302 128.778Z",
    fill: "url(#paint12_radial_2836_2053)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.012 127.208L209.657 127.993L168.825 87.1621L169.611 84.8064L212.012 127.208Z",
    fill: "url(#paint13_radial_2836_2053)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.725 125.637L214.369 126.423L170.396 82.4498L171.181 80.0941L216.725 125.637Z",
    fill: "url(#paint14_radial_2836_2053)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.436 124.067L219.08 124.852L171.967 77.7385L172.752 75.3828L221.436 124.067Z",
    fill: "url(#paint15_radial_2836_2053)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M226.148 122.496L223.792 123.282L173.537 73.0268L174.322 70.6711L226.148 122.496Z",
    fill: "url(#paint16_radial_2836_2053)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M230.858 120.926L228.503 121.711L175.107 68.3163L175.893 65.9606L230.858 120.926Z",
    fill: "url(#paint17_radial_2836_2053)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M235.571 119.355L233.215 120.141L176.678 63.6038L177.463 61.248L235.571 119.355Z",
    fill: "url(#paint18_radial_2836_2053)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240.282 117.785L237.926 118.57L178.248 58.8929L179.034 56.5372L240.282 117.785Z",
    fill: "url(#paint19_radial_2836_2053)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M244.993 116.215L242.637 117L179.819 54.1817L180.604 51.826L244.993 116.215Z",
    fill: "url(#paint20_radial_2836_2053)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249.704 114.644L247.348 115.43L181.389 49.4704L182.174 47.1147L249.704 114.644Z",
    fill: "url(#paint21_radial_2836_2053)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M254.415 113.074L252.059 113.859L182.96 44.7594L183.745 42.4037L254.415 113.074Z",
    fill: "url(#paint22_radial_2836_2053)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M259.127 111.503L256.771 112.289L184.53 40.0476L185.315 37.6919L259.127 111.503Z",
    fill: "url(#paint23_radial_2836_2053)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M263.838 109.933L261.482 110.718L186.101 35.3364L186.886 32.9807L263.838 109.933Z",
    fill: "url(#paint24_radial_2836_2053)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M268.55 108.362L266.194 109.148L187.671 30.6248L188.456 28.2691L268.55 108.362Z",
    fill: "url(#paint25_radial_2836_2053)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M273.261 106.792L270.905 107.577L189.242 25.9134L190.027 23.5576L273.261 106.792Z",
    fill: "url(#paint26_radial_2836_2053)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M277.974 105.221L275.618 106.006L190.812 21.2008L191.598 18.8451L277.974 105.221Z",
    fill: "url(#paint27_radial_2836_2053)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M282.685 103.651L280.329 104.436L192.383 16.4894L193.168 14.1337L282.685 103.651Z",
    fill: "url(#paint28_radial_2836_2053)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M287.396 102.08L285.04 102.866L193.953 11.7787L194.738 9.42302L287.396 102.08Z",
    fill: "url(#paint29_radial_2836_2053)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M292.107 100.51L289.752 101.295L195.524 7.06713L196.309 4.71143L292.107 100.51Z",
    fill: "url(#paint30_radial_2836_2053)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M296.819 98.9394L294.463 99.7246L197.094 2.35571L197.879 0L296.819 98.9394Z",
    fill: "url(#paint31_radial_2836_2053)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.41 148.409L147.625 146.055L146.055 147.626L148.41 148.409L146.055 149.195L147.625 150.765L148.41 148.409L149.195 150.767L150.766 149.196L148.41 148.409Z",
    fill: "url(#paint32_radial_2836_2053)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M143.698 146.84L141.342 146.055L146.054 141.343L146.839 143.699L143.698 146.84Z",
    fill: "url(#paint33_radial_2836_2053)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.987 145.27L136.631 144.484L144.484 136.632L145.269 138.988L138.987 145.27Z",
    fill: "url(#paint34_radial_2836_2053)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M134.276 143.699L131.92 142.914L142.913 131.921L143.699 134.276L134.276 143.699Z",
    fill: "url(#paint35_radial_2836_2053)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.564 142.129L127.209 141.344L141.343 127.21L142.128 129.565L129.564 142.129Z",
    fill: "url(#paint36_radial_2836_2053)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.852 140.558L122.496 139.773L139.772 122.497L140.557 124.853L124.852 140.558Z",
    fill: "url(#paint37_radial_2836_2053)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M120.141 138.988L117.785 138.202L138.202 117.786L138.987 120.141L120.141 138.988Z",
    fill: "url(#paint38_radial_2836_2053)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M115.43 137.417L113.074 136.632L136.631 113.075L137.417 115.43L115.43 137.417Z",
    fill: "url(#paint39_radial_2836_2053)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.719 135.847L108.363 135.062L135.061 108.364L135.846 110.72L110.719 135.847Z",
    fill: "url(#paint40_radial_2836_2053)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.008 134.277L103.652 133.491L133.491 103.653L134.276 106.008L106.008 134.277Z",
    fill: "url(#paint41_radial_2836_2053)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.296 132.706L98.9401 131.921L131.92 98.9408L132.705 101.297L101.296 132.706Z",
    fill: "url(#paint42_radial_2836_2053)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5853 131.136L94.2296 130.351L130.35 94.2303L131.135 96.586L96.5853 131.136Z",
    fill: "url(#paint43_radial_2836_2053)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8728 129.565L89.5171 128.78L128.779 89.5178L129.564 91.8735L91.8728 129.565Z",
    fill: "url(#paint44_radial_2836_2053)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1616 127.995L84.8059 127.209L127.209 84.8066L127.994 87.1623L87.1616 127.995Z",
    fill: "url(#paint45_radial_2836_2053)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4492 126.424L80.0935 125.639L125.638 80.0943L126.423 82.45L82.4492 126.424Z",
    fill: "url(#paint46_radial_2836_2053)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7386 124.854L75.3829 124.068L124.068 75.3836L124.853 77.7393L77.7386 124.854Z",
    fill: "url(#paint47_radial_2836_2053)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M73.027 123.283L70.6713 122.498L122.497 70.672L123.282 73.0277L73.027 123.283Z",
    fill: "url(#paint48_radial_2836_2053)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3157 121.713L65.96 120.927L120.927 65.9607L121.712 68.3165L68.3157 121.713Z",
    fill: "url(#paint49_radial_2836_2053)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6039 120.142L61.2482 119.357L119.356 61.249L120.141 63.6047L63.6039 120.142Z",
    fill: "url(#paint50_radial_2836_2053)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8931 118.572L56.5374 117.786L117.786 56.5381L118.571 58.8938L58.8931 118.572Z",
    fill: "url(#paint51_radial_2836_2053)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1819 117.001L51.8261 116.216L116.215 51.8269L117.001 54.1826L54.1819 117.001Z",
    fill: "url(#paint52_radial_2836_2053)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4701 115.431L47.1144 114.645L114.645 47.1151L115.43 49.4708L49.4701 115.431Z",
    fill: "url(#paint53_radial_2836_2053)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7587 113.86L42.4029 113.075L113.074 42.4037L113.86 44.7594L44.7587 113.86Z",
    fill: "url(#paint54_radial_2836_2053)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0478 112.29L37.6921 111.505L111.504 37.6928L112.289 40.0485L40.0478 112.29Z",
    fill: "url(#paint55_radial_2836_2053)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3365 110.72L32.9808 109.934L109.934 32.9816L110.719 35.3373L35.3365 110.72Z",
    fill: "url(#paint56_radial_2836_2053)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.624 109.149L28.2683 108.363L108.363 28.2691L109.148 30.6248L30.624 109.149Z",
    fill: "url(#paint57_radial_2836_2053)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9128 107.578L23.5571 106.793L106.792 23.5578L107.578 25.9135L25.9128 107.578Z",
    fill: "url(#paint58_radial_2836_2053)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2012 106.008L18.8455 105.223L105.222 18.8462L106.007 21.2019L21.2012 106.008Z",
    fill: "url(#paint59_radial_2836_2053)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4894 104.437L14.1337 103.652L103.651 14.1344L104.436 16.4901L16.4894 104.437Z",
    fill: "url(#paint60_radial_2836_2053)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7791 102.867L9.42338 102.082L102.081 9.4241L102.866 11.7798L11.7791 102.867Z",
    fill: "url(#paint61_radial_2836_2053)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06712 101.296L4.71141 100.511L100.51 4.71213L101.296 7.06784L7.06712 101.296Z",
    fill: "url(#paint62_radial_2836_2053)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35571 99.7259L0 98.9407L98.94 0.000720818L99.7252 2.35643L2.35571 99.7259Z",
    fill: "url(#paint63_radial_2836_2053)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M149.98 153.123L150.766 155.478L155.477 150.767L153.122 149.981L149.98 153.123Z",
    fill: "url(#paint64_radial_2836_2053)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M151.551 157.834L152.336 160.19L160.189 152.337L157.833 151.552L151.551 157.834Z",
    fill: "url(#paint65_radial_2836_2053)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M153.121 162.546L153.907 164.901L164.9 153.908L162.545 153.122L153.121 162.546Z",
    fill: "url(#paint66_radial_2836_2053)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M154.692 167.256L155.477 169.612L169.611 155.478L167.255 154.692L154.692 167.256Z",
    fill: "url(#paint67_radial_2836_2053)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M156.262 171.967L157.047 174.323L174.322 157.048L171.966 156.263L156.262 171.967Z",
    fill: "url(#paint68_radial_2836_2053)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M157.832 176.678L158.618 179.034L179.033 158.618L176.678 157.833L157.832 176.678Z",
    fill: "url(#paint69_radial_2836_2053)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M159.403 181.39L160.188 183.746L183.745 160.189L181.389 159.404L159.403 181.39Z",
    fill: "url(#paint70_radial_2836_2053)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M160.973 186.101L161.759 188.457L188.456 161.759L186.101 160.974L160.973 186.101Z",
    fill: "url(#paint71_radial_2836_2053)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M162.544 190.813L163.329 193.169L193.168 163.33L190.812 162.545L162.544 190.813Z",
    fill: "url(#paint72_radial_2836_2053)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M164.114 195.525L164.9 197.88L197.879 164.901L195.524 164.115L164.114 195.525Z",
    fill: "url(#paint73_radial_2836_2053)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M165.685 200.236L166.47 202.592L202.591 166.471L200.235 165.686L165.685 200.236Z",
    fill: "url(#paint74_radial_2836_2053)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M167.256 204.948L168.041 207.304L207.303 168.042L204.948 167.257L167.256 204.948Z",
    fill: "url(#paint75_radial_2836_2053)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M168.826 209.659L169.611 212.015L212.014 169.612L209.658 168.827L168.826 209.659Z",
    fill: "url(#paint76_radial_2836_2053)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M170.396 214.37L171.182 216.726L216.725 171.182L214.37 170.397L170.396 214.37Z",
    fill: "url(#paint77_radial_2836_2053)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M171.967 219.082L172.752 221.438L221.437 172.753L219.081 171.968L171.967 219.082Z",
    fill: "url(#paint78_radial_2836_2053)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M173.537 223.793L174.322 226.149L226.148 174.323L223.792 173.538L173.537 223.793Z",
    fill: "url(#paint79_radial_2836_2053)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M175.107 228.503L175.893 230.859L230.858 175.893L228.503 175.108L175.107 228.503Z",
    fill: "url(#paint80_radial_2836_2053)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M176.678 233.216L177.463 235.572L235.571 177.464L233.215 176.679L176.678 233.216Z",
    fill: "url(#paint81_radial_2836_2053)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M178.249 237.927L179.034 240.283L240.282 179.035L237.927 178.25L178.249 237.927Z",
    fill: "url(#paint82_radial_2836_2053)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M179.819 242.639L180.604 244.994L244.994 180.605L242.638 179.82L179.819 242.639Z",
    fill: "url(#paint83_radial_2836_2053)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M181.39 247.351L182.175 249.706L249.706 182.176L247.35 181.391L181.39 247.351Z",
    fill: "url(#paint84_radial_2836_2053)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M182.96 252.062L183.745 254.417L254.416 183.746L252.061 182.961L182.96 252.062Z",
    fill: "url(#paint85_radial_2836_2053)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M184.531 256.774L185.316 259.129L259.128 185.317L256.773 184.532L184.531 256.774Z",
    fill: "url(#paint86_radial_2836_2053)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M186.101 261.485L186.886 263.841L263.84 186.887L261.484 186.102L186.101 261.485Z",
    fill: "url(#paint87_radial_2836_2053)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M187.671 266.196L188.457 268.551L268.551 188.458L266.195 187.672L187.671 266.196Z",
    fill: "url(#paint88_radial_2836_2053)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M189.242 270.907L190.027 273.263L273.262 190.028L270.906 189.243L189.242 270.907Z",
    fill: "url(#paint89_radial_2836_2053)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M190.812 275.619L191.598 277.974L277.974 191.599L275.618 190.813L190.812 275.619Z",
    fill: "url(#paint90_radial_2836_2053)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M192.383 280.33L193.168 282.686L282.685 193.169L280.33 192.384L192.383 280.33Z",
    fill: "url(#paint91_radial_2836_2053)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M193.953 285.041L194.738 287.397L287.396 194.739L285.04 193.954L193.953 285.041Z",
    fill: "url(#paint92_radial_2836_2053)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M195.524 289.753L196.309 292.109L292.108 196.31L289.753 195.525L195.524 289.753Z",
    fill: "url(#paint93_radial_2836_2053)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M197.094 294.465L197.88 296.82L296.82 197.881L294.464 197.095L197.094 294.465Z",
    fill: "url(#paint94_radial_2836_2053)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M146.839 153.122L146.054 155.477L141.343 150.766L143.698 149.981L146.839 153.122Z",
    fill: "url(#paint95_radial_2836_2053)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M145.269 157.833L144.484 160.189L136.631 152.336L138.987 151.551L145.269 157.833Z",
    fill: "url(#paint96_radial_2836_2053)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M143.699 162.544L142.913 164.899L131.92 153.907L134.276 153.121L143.699 162.544Z",
    fill: "url(#paint97_radial_2836_2053)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M142.128 167.255L141.343 169.611L127.209 155.477L129.565 154.692L142.128 167.255Z",
    fill: "url(#paint98_radial_2836_2053)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M140.558 171.967L139.772 174.322L122.498 157.048L124.853 156.262L140.558 171.967Z",
    fill: "url(#paint99_radial_2836_2053)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M138.987 176.678L138.202 179.034L117.786 158.618L120.142 157.833L138.987 176.678Z",
    fill: "url(#paint100_radial_2836_2053)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M137.417 181.389L136.632 183.745L113.075 160.188L115.431 159.403L137.417 181.389Z",
    fill: "url(#paint101_radial_2836_2053)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M135.846 186.1L135.061 188.456L108.364 161.759L110.72 160.974L135.846 186.1Z",
    fill: "url(#paint102_radial_2836_2053)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M134.276 190.813L133.49 193.168L103.652 163.33L106.007 162.544L134.276 190.813Z",
    fill: "url(#paint103_radial_2836_2053)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M132.705 195.524L131.92 197.879L98.9405 164.9L101.296 164.115L132.705 195.524Z",
    fill: "url(#paint104_radial_2836_2053)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M131.135 200.234L130.35 202.59L94.23 166.47L96.5857 165.685L131.135 200.234Z",
    fill: "url(#paint105_radial_2836_2053)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M129.564 204.947L128.779 207.302L89.5175 168.041L91.8732 167.256L129.564 204.947Z",
    fill: "url(#paint106_radial_2836_2053)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M127.994 209.658L127.209 212.014L84.8063 169.611L87.162 168.826L127.994 209.658Z",
    fill: "url(#paint107_radial_2836_2053)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M126.423 214.369L125.638 216.725L80.0947 171.182L82.4504 170.397L126.423 214.369Z",
    fill: "url(#paint108_radial_2836_2053)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M124.853 219.081L124.068 221.437L75.3833 172.752L77.739 171.967L124.853 219.081Z",
    fill: "url(#paint109_radial_2836_2053)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M123.282 223.793L122.497 226.148L70.6715 174.323L73.0272 173.538L123.282 223.793Z",
    fill: "url(#paint110_radial_2836_2053)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M121.712 228.503L120.927 230.859L65.9612 175.893L68.3169 175.108L121.712 228.503Z",
    fill: "url(#paint111_radial_2836_2053)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M120.141 233.215L119.356 235.57L61.2494 177.464L63.6051 176.678L120.141 233.215Z",
    fill: "url(#paint112_radial_2836_2053)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M118.571 237.927L117.786 240.282L56.5376 179.034L58.8933 178.249L118.571 237.927Z",
    fill: "url(#paint113_radial_2836_2053)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M117 242.638L116.215 244.994L51.8264 180.605L54.1821 179.819L117 242.638Z",
    fill: "url(#paint114_radial_2836_2053)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M115.43 247.349L114.645 249.705L47.1148 182.175L49.4705 181.39L115.43 247.349Z",
    fill: "url(#paint115_radial_2836_2053)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M113.86 252.06L113.074 254.416L42.4041 183.745L44.7598 182.96L113.86 252.06Z",
    fill: "url(#paint116_radial_2836_2053)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 256.772L111.504 259.127L37.6925 185.316L40.0482 184.531L112.289 256.772Z",
    fill: "url(#paint117_radial_2836_2053)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M110.719 261.483L109.934 263.839L32.9813 186.886L35.337 186.101L110.719 261.483Z",
    fill: "url(#paint118_radial_2836_2053)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M109.148 266.195L108.363 268.551L28.2688 188.457L30.6245 187.672L109.148 266.195Z",
    fill: "url(#paint119_radial_2836_2053)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M107.578 270.906L106.793 273.262L23.5583 190.027L25.914 189.242L107.578 270.906Z",
    fill: "url(#paint120_radial_2836_2053)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M106.007 275.618L105.222 277.974L18.8457 191.598L21.2015 190.813L106.007 275.618Z",
    fill: "url(#paint121_radial_2836_2053)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M104.437 280.329L103.651 282.685L14.1349 193.168L16.4906 192.383L104.437 280.329Z",
    fill: "url(#paint122_radial_2836_2053)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M102.866 285.041L102.081 287.396L9.42365 194.739L11.7794 193.954L102.866 285.041Z",
    fill: "url(#paint123_radial_2836_2053)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M101.296 289.752L100.51 292.108L4.71186 196.309L7.06757 195.524L101.296 289.752Z",
    fill: "url(#paint124_radial_2836_2053)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7254 294.463L98.9402 296.819L0.00118364 197.88L2.35688 197.094L99.7254 294.463Z",
    fill: "url(#paint125_radial_2836_2053)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_2836_2053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.986 148.409) rotate(128.199) scale(155.602 155.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangles);
export default __webpack_public_path__ + "static/media/triangles.71c5a920da5a876731411a3c2790e640.svg";
export { ForwardRef as ReactComponent };